__turbopack_context__.v({
  "card": "ProgressSlide-module-scss-module__ILzO5G__card",
  "card__img": "ProgressSlide-module-scss-module__ILzO5G__card__img",
  "card__img_common": "ProgressSlide-module-scss-module__ILzO5G__card__img_common",
  "card__overlay": "ProgressSlide-module-scss-module__ILzO5G__card__overlay",
  "contentLength": "ProgressSlide-module-scss-module__ILzO5G__contentLength",
  "date": "ProgressSlide-module-scss-module__ILzO5G__date",
  "date__day": "ProgressSlide-module-scss-module__ILzO5G__date__day",
  "date__inner": "ProgressSlide-module-scss-module__ILzO5G__date__inner",
  "date__line": "ProgressSlide-module-scss-module__ILzO5G__date__line",
  "date__month": "ProgressSlide-module-scss-module__ILzO5G__date__month",
  "date__year": "ProgressSlide-module-scss-module__ILzO5G__date__year",
  "generalCard": "ProgressSlide-module-scss-module__ILzO5G__generalCard",
  "generalDate": "ProgressSlide-module-scss-module__ILzO5G__generalDate",
  "generalStage": "ProgressSlide-module-scss-module__ILzO5G__generalStage",
  "generalWrapper": "ProgressSlide-module-scss-module__ILzO5G__generalWrapper",
  "paragraph": "ProgressSlide-module-scss-module__ILzO5G__paragraph",
  "svg": "ProgressSlide-module-scss-module__ILzO5G__svg",
  "svgBox": "ProgressSlide-module-scss-module__ILzO5G__svgBox",
  "wrapper": "ProgressSlide-module-scss-module__ILzO5G__wrapper",
});
